module.exports = __webpack_public_path__ + "static/media/template-head-white.b2d43a9a.jpg";